// The ONE place the app's store listings and deep-link scheme live. Every
// "get the app" surface (footer, banners, admin gate, the mobile hand-off)
// reads these — five components used to carry their own copies.
export const APP_STORE = {
  ios: 'https://apps.apple.com/us/app/squash-leagues-ladders/id1415056784',
  android: 'https://play.google.com/store/apps/details?id=org.squashleagues.squashleaguesladders&hl=en&gl=US',
};

export const IOS_APP_ID = '1415056784';

/**
 * The app's custom URL scheme for this site's host. The app rebuilds the path
 * from the URL's host + path (`tapleagues://fixtures/abc` → `/fixtures/abc`),
 * so a site-relative path becomes `<scheme>://<path-without-leading-slash>`.
 * Prod builds register `tapleagues`; the stg build (uat) `tapleagues-stg`.
 */
export function appSchemeForHost(host) {
  const h = (host || '').toLowerCase();
  if (h.includes('local.tapleagues') || h.startsWith('localhost') || h.startsWith('127.')) return 'tapleagues-local';
  if (h.includes('uat.tapleagues') || h.includes('tapleaguesuatfrontend')) return 'tapleagues-stg';
  return 'tapleagues';
}

export function appSchemeUrl(host, path) {
  const clean = (path || '/').replace(/^\/+/, '');
  return `${appSchemeForHost(host)}://${clean}`;
}
